<div class="d-block modal" @zoomIn @zoomOut>
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-sm-down">
        <div class="modal-content shadow-lg">
            <div class="modal-header bg-secondary text-white">
                <h5 class="modal-title">Reset Password</h5>
                <button type="button" class="btn-close" title="Close" (click)="dismiss()"></button>
            </div>
            <div class="modal-body">
                <div class="px-md-3 px-xl-2 pt-4">
                    @if (!sent) {
                    <form autocomplete="off" class="form-validate form-inline" [formGroup]="forgotPasswordForm"
                        (ngSubmit)="onSubmit($event)">
                        <div class="form-group">
                            <div class="form-group mb-2">
                                <label for="email">Email Address</label>
                                <input placeholder="Your Email" autocomplete="off" class="form-control"
                                    formControlName="email" />
                            </div>
                            <button type="button" class="btn btn-primary mb-2" [disabled]="working"
                                (click)="onSubmit($event)">
                                @if (!working) { Send Reset Link } @else { Sending... }
                            </button>
                            @if (message) {
                            <div class="text-danger">{{ message }}</div>
                            }
                            <hr data-content="Enter your email address" class="mt-2 hr-text letter-spacing-1">
                            <p class="text-muted">We'll email you a link to reset your password.</p>
                        </div>
                    </form>
                    } @else {
                    <p class="text-muted">
                        If that email is registered with us, we've sent a link to reset your password.
                        It expires in 60 minutes.
                    </p>
                    }
                </div>
                <div class="mt-4 modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="dismiss()">Close</button>
                </div>
            </div>
        </div>
    </div>
